const getIsAssistedSalesEnabled = configuration =>
  configuration?.app?.assistedSales?.enabled ?? true;

module.exports = { getIsAssistedSalesEnabled };
